<template>
    <div class="mdc-form-field">
        <div class="mdc-radio">
            <input type="radio" class="mdc-radio__native-control" v-model="checked" :value="value" v-bind="$attrs" />

            <div class="mdc-radio__background">
                <div class="mdc-radio__outer-circle"></div>
                <div class="mdc-radio__inner-circle"></div>
            </div>
        </div>
        <label :for="id" class="mb-0">
            <slot></slot>
        </label>
    </div>
</template>

<script>
export default {
    inheritAttrs: false,
    model: {
        prop: 'modelValue',
        event: 'change'
    },
    props: {
        modelValue: Number | String,
        value: Number | String,
        id: Number | String
    },
    computed: {
        checked: {
            get() {
                return this.modelValue;
            },
            set(newVal) {
                this.$emit('change', newVal);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import '@sass/_variables.scss';

.mdc-radio__outer-circle {
    border-radius: 50%;
    border-color: $grey !important;
    transition: border-color 120ms 0ms cubic-bezier(0.4, 0, 0.6, 1);
}

/**
* Ajustes dos component do Material Design
*
* Correções de todos componentes utilizados
* no projeto do Material Design.
*
* @css-for all components in use
*/

/** Standard - blue */
.mdc-radio .mdc-radio__native-control:enabled:checked + .mdc-radio__background .mdc-radio__outer-circle {
    border-color: var(--v-primary-base) !important;
}

.mdc-radio .mdc-radio__native-control:enabled + .mdc-radio__background .mdc-radio__inner-circle {
    border-color: var(--v-primary-base) !important;
}

/** green [radio-success] */
.mdc-radio.radio-success .mdc-radio__native-control:enabled:checked + .mdc-radio__background .mdc-radio__outer-circle {
    border-color: $green-radio-border !important;
}
.mdc-radio.radio-success .mdc-radio__native-control:enabled + .mdc-radio__background .mdc-radio__inner-circle {
    border-color: $green-radio !important;
}
.mdc-radio.radio-success .mdc-radio__background .mdc-radio__outer-circle {
    border-color: $green-radio !important;
}

/** red [radio-error] */
.mdc-radio.radio-error .mdc-radio__native-control:enabled:checked + .mdc-radio__background .mdc-radio__outer-circle {
    border-color: $red-dark !important;
}
.mdc-radio.radio-error .mdc-radio__native-control:enabled + .mdc-radio__background .mdc-radio__inner-circle {
    border-color: $red-dark !important;
}
.mdc-radio.radio-error .mdc-radio__background .mdc-radio__outer-circle {
    border-color: $red-dark !important;
}
</style>
